module.exports = __webpack_public_path__ + "img/logo-green.ec8391d4.png";